import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-finance-transfer",
  "use": "icon-finance-transfer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-finance-transfer\">\r\n  <defs><style type=\"text/css\"></style></defs>\r\n  <path d=\"M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m0 832c-211.2 0-384-172.8-384-384s172.8-384 384-384 384 172.8 384 384-172.8 384-384 384z\" p-id=\"2118\" />\r\n  <path d=\"M320 448l128-128v80h128v96H448v80z\" p-id=\"2119\" />\r\n  <path d=\"M704 448l-128 128v-80H448v-96h128v-80z\" p-id=\"2120\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance-transfer.svg
// module id = K/yO
// module chunks = 48